export default __webpack_public_path__ + "static/media/equitiesImg.f3ea9092.webp";